import Editor from "/src/features/editor/components/Editor";
import TreeContextProvider from "/src/features/editor/contexts/TreeContext";
import CameraContextProvider from "../../features/editor/contexts/CameraContext";
import BotContextProvider from "/src/features/editor/contexts/BotContext";
import { useLocation } from "react-router-dom";
import ChatboxWindow from '../../features/chatbox/components/ChatboxWindow/ChatboxWindow';
import ChatboxContextProvider from '../../features/chatbox/context/ChatboxContext'
import ConversationContextProvider from '../../features/chatbox/context/ConversationContext';
import { useBotStateContext } from "/src/features/editor/contexts/BotContext";
import { useConversationDispatchContext } from "../../features/chatbox/context/ConversationContext";
import '../../features/chatbox/App.css';
import { useEffect } from "react";
import storage from "/src/utils/storage";
import { env } from '../../var/env'

const EditorWithChatbox = ({bot, config}) => {
    const { botName, blockStart } = useBotStateContext();
    const dispatch = useConversationDispatchContext();
    useEffect(() => {
        dispatch({type : 'restartConversation'})
        dispatch({type : 'init', payload: {...config} })
    }, [bot]);

    const isShowingChatbox = botName && botName == bot && blockStart != undefined;

    return (
        <>
            <TreeContextProvider>
                <CameraContextProvider>
                    <Editor bot={bot}/>
                    </CameraContextProvider>
                </TreeContextProvider>
            { isShowingChatbox ? <ChatboxWindow/> : null}
        </>
    )
}

function BotEditor() {

    const location = useLocation();
    var bot = location.pathname.split('/').pop();

    const { name } = storage('session').get('company');
    const backEndOrigin = new URL(env.REACT_APP_API_PATH).origin;

    const configChatbox = { bot, company : name, backEndService : backEndOrigin, mode : 'debug' }

    return (
        <>
         <ConversationContextProvider config={configChatbox}>
            <ChatboxContextProvider>
                <BotContextProvider>
                    <EditorWithChatbox bot={bot} config={configChatbox}/>
                </BotContextProvider>
            </ChatboxContextProvider>
        </ConversationContextProvider>
        </>
    );
}
export default BotEditor;